var React = require('react');

function Healthcare (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M14.62,11.5l-2,4.06a.65.65,0,0,1-1.18,0L9.09,10.38,7.86,13.31H4l7.45,7.62a.73.73,0,0,0,1,0L20,13.31H15.53Z","key":0}),React.createElement("path",{"d":"M20.89,4.56l-.09-.1a5.35,5.35,0,0,0-7.66,0L12,5.63,10.86,4.46a5.35,5.35,0,0,0-7.66,0l-.09.1A5.61,5.61,0,0,0,2.81,12H7L8.46,8.48a.65.65,0,0,1,1.2,0L12,13.75l2-4a.65.65,0,0,1,1.17,0L16.34,12h4.85A5.61,5.61,0,0,0,20.89,4.56Z","key":1})]);
}

Healthcare.defaultProps = {"fill":"currentColor","id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 24 24"};

module.exports = Healthcare;

Healthcare.default = Healthcare;
